import { GET_FEES_WORKSHEETS } from './types';

export const getFeesWorksheet = (payload) => ({
  type: GET_FEES_WORKSHEETS,
  payload,
});
